import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {SetActiveExploreMode, SetActivePapayaViewMode} from './scan-viewer.actions';
import {EXPLORE_MODE, PAPAYA_SLICES} from '../../symbols/papaya.symbols';
import {MainDashboardStateModel} from './scan-viewer.models';

const STATE_DEFAULTS: MainDashboardStateModel = {
  activeExploreMode: null,
  activePapayaSlice: PAPAYA_SLICES.SURFACE,
};

@State<MainDashboardStateModel>({
  name: 'main_dashboard',
  defaults: STATE_DEFAULTS,
})
@Injectable()
export class ScanViewerState {
  @Selector()
  static activeExploreMode(state: MainDashboardStateModel): EXPLORE_MODE {
    return state.activeExploreMode;
  }

  @Selector()
  static activePapayaSlice(state: MainDashboardStateModel): PAPAYA_SLICES {
    return state.activePapayaSlice;
  }

  @Action(SetActiveExploreMode)
  setActiveExploreMode(
    {patchState}: StateContext<MainDashboardStateModel>,
    {exploreMode}: SetActiveExploreMode
  ): void {
    patchState({
      activeExploreMode: exploreMode,
    });
  }

  @Action(SetActivePapayaViewMode)
  setActivePapayaViewMode(
    {patchState}: StateContext<MainDashboardStateModel>,
    {viewMode}: SetActivePapayaViewMode
  ): void {
    patchState({
      activePapayaSlice: viewMode,
    });
  }
}
